import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

export interface PpiRekapUnitRow {
  unit_id: string | null;
  unit_nama: string;
  n_sesi: number;
  den: number;
  rate: number | null;
}

export interface PpiRekapData {
  module: string;
  label: string;
  from: string;
  to: string;
  months: string[];
  monthly: {
    n_sesi: number[];
    rates: Array<number | null>;
  };
  units: PpiRekapUnitRow[];
}

async function getRekap(params: {
  module: string;
  from?: string;
  to?: string;
  unit_id?: string;
}) {
  const response = await http
    .getDataParam("/ppi/rekap", { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

export default {
  getRekap
};
